
var id = "portrayal";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"portrayal\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 22.4a489.6 489.6 0 1 0 0 979.2A489.6 489.6 0 0 0 512 22.4z m0 83.2a406.4 406.4 0 1 1 0 812.8 406.4 406.4 0 0 1 0-812.8z\" p-id=\"13815\" /><path d=\"M512 534.4a425.536 425.536 0 0 1 374.848 223.808l7.552 14.848-74.688 36.544A342.4 342.4 0 0 0 512 617.6a342.272 342.272 0 0 0-297.344 172.48l-7.296 13.44-73.984-38.08A425.536 425.536 0 0 1 512 534.4zM512 150.4a169.6 169.6 0 1 0 0 339.2 169.6 169.6 0 0 0 0-339.2z m0 83.2a86.4 86.4 0 1 1 0 172.8 86.4 86.4 0 0 1 0-172.8z\" p-id=\"13816\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
